import React, { Component } from 'react';
import RedactedChip from '../../../../components/redacted-chip';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import { loadAiEligibleReport, downloadReport } from '../../data-dictionary-view.actions';
import ReportShell from './report-shell';

const APPROVAL_STATUS_OPTIONS = ['Approved', 'Pending', 'Rejected'];
const ELIGIBLE_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Yes', value: 'Y' },
  { label: 'No', value: 'N' },
];

class AiEligibleReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      approvalStatus: '',
      schema: '',
      eligible: '',
      search: '',
    };
  }

  componentDidMount() {
    this.loadReport();
  }

  loadReport = () => {
    const { approvalStatus, schema, eligible, search } = this.state;
    this.props.loadAiEligibleReport({ approvalStatus, schema, eligible, search });
  }

  handleFilterChange = (field) => (e) => {
    this.setState({ [field]: e.target.value }, this.loadReport);
  }

  handleDownload = () => {
    const { approvalStatus, schema, eligible, search } = this.state;
    this.props.downloadReport('ai-eligible', { approvalStatus, schema, eligible, search });
  }

  handleCardClick = (key) => {
    const current = this.state.approvalStatus;
    const next = (key === 'total' || current === key) ? '' : key;
    this.setState({ approvalStatus: next }, this.loadReport);
  }

  getSummaryTiles(data) {
    const counts = data.reduce((acc, r) => {
      const status = (r.approvalStatus || '').toLowerCase();
      if (status === 'approved') acc.approved++;
      else if (status === 'pending') acc.pending++;
      else if (status === 'rejected') acc.rejected++;
      return acc;
    }, { approved: 0, pending: 0, rejected: 0 });
    const { approvalStatus } = this.state;
    return [
      { label: 'Total', value: data.length, className: 'total', key: 'total', isActive: !approvalStatus, onClick: () => this.handleCardClick('total') },
      { label: 'Approved', value: counts.approved, className: 'approved', key: 'Approved', isActive: approvalStatus === 'Approved', onClick: () => this.handleCardClick('Approved') },
      { label: 'Pending', value: counts.pending, className: 'pending', key: 'Pending', isActive: approvalStatus === 'Pending', onClick: () => this.handleCardClick('Pending') },
      { label: 'Rejected', value: counts.rejected, className: 'rejected', key: 'Rejected', isActive: approvalStatus === 'Rejected', onClick: () => this.handleCardClick('Rejected') },
    ];
  }

  renderFilters() {
    const { approvalStatus, schema, eligible, search } = this.state;
    const { schemas } = this.props;
    return (
      <div className="dd-view-filter-row">
        <TextField
          select
          label="Approval Status"
          value={approvalStatus}
          onChange={this.handleFilterChange('approvalStatus')}
          variant="standard"
          fullWidth
        >
          <MenuItem value="">All</MenuItem>
          {APPROVAL_STATUS_OPTIONS.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
        </TextField>
        <TextField
          select
          label="Schema"
          value={schema}
          onChange={this.handleFilterChange('schema')}
          variant="standard"
          fullWidth
        >
          <MenuItem value="">All</MenuItem>
          {Array.isArray(schemas) && schemas.map(s => (
            <MenuItem key={s.schemaId} value={s.schemaId}>{s.instanceName} ({s.schemaName})</MenuItem>
          ))}
        </TextField>
        <TextField
          select
          label="AI Sensitive"
          value={eligible}
          onChange={this.handleFilterChange('eligible')}
          variant="standard"
          fullWidth
        >
          {ELIGIBLE_OPTIONS.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
        </TextField>
        <TextField
          label="Search"
          value={search}
          onChange={this.handleFilterChange('search')}
          variant="standard"
          fullWidth
          InputProps={{
            endAdornment: search && (
              <InputAdornment position="end">
                <i className="material-icons search-clear" onClick={() => this.setState({ search: '' }, this.loadReport)}>close</i>
              </InputAdornment>
            )
          }}
        />
      </div>
    );
  }

  renderTable(data) {
    return (
      <div className="object-table-container">
        <table className="object-table">
          <thead>
            <tr>
              <th>Schema</th>
              <th>Table</th>
              <th>Description</th>
              <th>AI Sensitive</th>
              <th>Approval Status</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                <td>{row.schema}</td>
                <td>{row.table}</td>
                <td>{(row.redactedFields || []).includes('description') ?
                  <RedactedChip fields={row.redactedFields} data-testid="dd-ai-redacted" /> :
                  row.description}</td>
                <td>
                  <span className={`dd-badge ${row.eligible === 'Y' ? 'badge-approved' : 'badge-rejected'}`}>
                    {row.eligible === 'Y' ? 'Yes' : 'No'}
                  </span>
                </td>
                <td>
                  <span className={`dd-badge badge-${(row.approvalStatus || '').toLowerCase()}`}>
                    {row.approvalStatus}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { aiEligibleReport, onBack } = this.props;
    const data = aiEligibleReport.data || [];

    return (
      <ReportShell
        title="AI Sensitive Report"
        icon="smart_toy"
        summaryTiles={this.getSummaryTiles(data)}
        filters={this.renderFilters()}
        table={this.renderTable(data)}
        isLoading={aiEligibleReport.isLoading}
        error={aiEligibleReport.error}
        data={data}
        onBack={onBack}
        onDownload={this.handleDownload}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  aiEligibleReport: state.dataDictionaryViewReducer.reports.aiEligible,
  schemas: state.dataDictionaryViewReducer.schemas,
});

export default connect(mapStateToProps, { loadAiEligibleReport, downloadReport })(AiEligibleReport);
